export default "__VITE_ASSET__TEFQej3F__"